/**
 * AssetCategoryService
 * Service for AssetCategory lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetCategory CRUD operations */
export class AssetCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetCategoryService.DEFAULT_SERVICE_PATH,
            basePath: AssetCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetCategoryService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetCategoryService.BASE_PATH = 'api/asset-categories';
//# sourceMappingURL=AssetCategoryService.js.map